import { render, staticRenderFns } from "./DemandForm.vue?vue&type=template&id=61746179&scoped=true"
import script from "./DemandForm.vue?vue&type=script&lang=js"
export * from "./DemandForm.vue?vue&type=script&lang=js"
import style0 from "./DemandForm.vue?vue&type=style&index=0&id=61746179&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61746179",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61746179')) {
      api.createRecord('61746179', component.options)
    } else {
      api.reload('61746179', component.options)
    }
    module.hot.accept("./DemandForm.vue?vue&type=template&id=61746179&scoped=true", function () {
      api.rerender('61746179', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/back/RecruitManage/Demand/DemandForm.vue"
export default component.exports